"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatNumber = void 0;
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns props `value` formatted as the number.
 * @see {@link useFormatNumber} for more information.
 *
 * @see {@link FormatNumberProps} for the available props and options.
 * @example
  // basic usage
  <FormatNumber value={1234.567} />

  // specify number of decimals to display
  <FormatNumber value={1234.567} options={{ decimals: 2 }} />
 */
const FormatNumber = ({
  children,
  value,
  options
}) => {
  const formattedValue = (0, _hooks.useFormatNumber)(value ?? children, options);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- false positive
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: formattedValue
  });
};
exports.FormatNumber = FormatNumber;
